import DataSheets from '../components/DataSheets'

export default function DataPage() {
  return <DataSheets />
}
